import {useState} from 'react'
import {ApiConsumer, backend} from '@eitje/api'
import {ArrayField, Input, Message, ModalWithNewForm} from '~/components'
import {validateEmail} from '~/helpers'

const INSTRUCTIONS_URL = 'https://www.notion.so/eitjehq/Open-API-2a6769df95f94cafbf725329a0d0856d'

export const NewApiConsumer = () => {
	const [password, setPassword] = useState('')
	const [username, setUsername] = useState('')
	const [hideSubmit, setHideSubmit] = useState(false)
	const [submittedEmailCount, setSubmittedEmailCount] = useState(1)
	const emailArrayFieldFields = [{Component: Input, field: 'email', required: true, validate: validateEmail, readOnly: hideSubmit}]

	const handleSubmit = ({emails, ...data}) => backend.post('/api_consumers', {...data, emails: emails._map('email')})

	const afterSubmit = ({params, resData}) => {
		setPassword(resData.password)
		setUsername(resData.username)
		setSubmittedEmailCount(params.emails.length)
		setHideSubmit(true)
		ApiConsumer.index({refresh: true})
	}

	return (
		<ModalWithNewForm
			name="create_api_consumer"
			onSubmit={handleSubmit}
			afterSubmit={afterSubmit}
			initialValues={{password, username}}
			modalProps={{
				confirmSubmit: true,
				hideSubmit,
				watch: hideSubmit,
				okButtonProps: {
					t: 'common.create',
					iconLeft: 'checked',
					confirmText: {t: 'modals.create_api_consumer.confirm_message'},
					confirmButtonProps: {t: 'common.create'},
				},
			}}
			width={400}
		>
			<Message mdT={['modals.create_api_consumer.message', {INSTRUCTIONS_URL}]} />
			<Input field="username" required readOnly={hideSubmit} />
			<ArrayField
				addItemLabel="email"
				field="emails"
				fields={emailArrayFieldFields}
				minItems={hideSubmit ? submittedEmailCount : 1}
				readOnly={hideSubmit}
			/>
			{hideSubmit && <Input field="password" readOnly value={password} />}
		</ModalWithNewForm>
	)
}
